import { SearchVehicleModelRawResponse, SearchVehicleModelResponse } from "./types";

export const transformVehicleModel = (res: SearchVehicleModelRawResponse) => {
  const {
    _embedded: { model: models },
  } = res;

  const response: SearchVehicleModelResponse = {
    models: models.map((i) => ({
      id: i.uuid,
      make: i.make,
      model: i.model,
      avatar: i.avatar,
      serviceLevel: i.service_level,
      type: i.type,
    })),
  };

  return response;
};